export default class MeasureUnitHelper {
    static getMeasureUnitByProductProperty(measureUnits: any[], propertyName: string): string {
        let measureUnit = measureUnits.find(x => x.value === propertyName);
        if (measureUnit) {
            return measureUnit.title;
        } else {
            return '';
        }
    }
}